/**
 * Hook for handling error actions
 */
import { useCallback } from 'react';
export function useErrorAction({ setError, setIsLoading }) {
    const handleError = useCallback(async (payment, actionData, options = {}) => {
        const errorMsg = actionData.message || 'Payment processing failed';
        const errorCode = actionData.errorCode || 'PAYMENT_FAILED';
        setError(errorMsg);
        setIsLoading(false);
        // Legacy callback (backwards compatibility)
        options.onFailure?.(errorMsg);
        // Funnel-aligned callback (recommended)
        options.onPaymentFailed?.({
            code: errorCode,
            message: errorMsg,
            payment,
        });
    }, [setError, setIsLoading]);
    return { handleError };
}
